import type { Change } from 'diff'
import * as React from 'react'

export const DiffLine = ({
  diff,
  condition,
  as = 'div',
  ...rest
}: {
  as?: React.JSX.ElementType
  diff: Change[] | string
  condition: 'removed' | 'added'
} & Omit<React.HTMLAttributes<HTMLElement>, 'children'>) => {
  const Comp = as
  const result = Array.isArray(diff)
    ? diff.reduce((acc: React.ReactNode[], part, index) => {
        if (
          (part.added && condition === 'removed') ||
          (part.removed && condition === 'added')
        ) {
          return acc
        }

        let className = ''
        if (part[condition]) {
          className =
            condition === 'removed' ? 'bg-red-diff/40' : 'bg-green-diff/40'
        }

        return acc.concat(
          <span key={`part-${index}`} className={className}>
            {part.value}
          </span>
        )
      }, [])
    : diff
  return (
    <Comp {...rest}>
      {result.length === 0 ? (
        <span className="text-inherit italic font-regular">empty</span>
      ) : (
        result
      )}
    </Comp>
  )
}
